<template>
        <b-form-group
            :invalid-feedback="error"
            :label="__(config.label || config.name, ['titleCase'])"
            :label-for="'expandable-textarea-' + config.name">
            <small v-if="config.description" class="form-text mb-2">{{ config.description }}</small>
            <textarea
                class="form-control"
                v-on:input="(e) => onChange(e.target.value)"
                :id="'expandable-textare-' + config.name"
                :value="value"
                :rows="lines"
                :maxlength="config.length || ''"
                :disabled="config.readonly"
                ></textarea>
        </b-form-group>
</template>
<script>
import Vue from 'vue';
import V from 'voca';
import Datepicker from 'vuejs-datepicker';

export default {
    data () {
        return {
            initialized: false,
        }
    },

    props: ['value', 'label', 'required', 'config', 'state', 'error'],

    components: {
        Datepicker,
    },

    mounted() {

    },

    computed: {
        lines() {
            return String(this.value).split("\n").length + 1;
        }
    },

    watch: {

    },

    methods: {
        onChange(newValue) {
            this.$emit('input', newValue);
            this.$emit('change', newValue);
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/ExpandableTextComponent.vue